
class Image {
    static GetValueOrDefault(val,type=0){
        let text = "";
        if (val == "") {
          if(type==0){
            text ="/static/default.png";
          }
          else{
            text="/static/defaultLong.jpg"
          }
        }
        return text;
    }
}

export default Image


// WEBPACK FOOTER //
// ./src/tools/image.js